export const UNEXPECTED_ERROR_MESSAGE =
  "Une erreur inattendu s'est produite, aucun paiement n'a été effectué. Veuillez réessayer ultérieurement";

export const brands = ['amex', 'visa', 'mastercard'];
